import { Palette } from '@/themes/themeOverrides/Palette';

export const CustomThemePalette = {
    primary: {
        light: Palette.yellow.yellow200,
        main: Palette.yellow.yellow400,
        dark: Palette.yellow.yellow600,
    },
    secondary: {
        light: '#71C380',
        main: '#2AAA4A',
        dark: '#219B41',
    },
    error: {
        light: Palette.red.red200,
        main: Palette.red.red400,
        dark: Palette.red.red800,
    },
    warning: {
        light: Palette.yellow.yellow600,
        main: Palette.yellow.yellow700,
        dark: Palette.yellow.yellow800,
    },
    info: {
        light: Palette.blue.blue300,
        main: Palette.blue.blue500,
        dark: Palette.blue.blue700,
    },
    success: {
        light: '#C2E5C7',
        main: '#2AAA4A',
        dark: '#219B41',
    },
};
